import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import { useChUpdateTimeWindowMutation } from "@/modules/patients/services/ch/__generated__/useChUpdateTimeWindowMutation.graphql"

export const Ch_updateTimeWindowMutation = graphql`
  mutation useChUpdateTimeWindowMutation($input: Ch_updateTimeWindowInput!) {
    ch_updateTimeWindow(input: $input) {
      ch_TimeWindow {
        id
        referredBy
        dateFrom
        dateTo
        internalComment
        referralReason
        referralToCareProviderId
        referralToDoctorName
        referredByExternalCareProviderId
        progressNoteId
        alternativeTriage
        progressNote {
          id
          episodeOfCareId
          appointment {
            id
            language
          }
          pointOfCare {
            careProviderId
          }
          treatmentPlan {
            title
            followUpInstructions
            recommended
            from
            to
          }
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useUpdateSwissTimeWindowMutation = () => {
  return useMutation<useChUpdateTimeWindowMutation>(Ch_updateTimeWindowMutation)
}
